module.exports = __webpack_public_path__ + "img/fd02afe.png";